import { SimulationDetailsInterface } from '../../../../interfaces/dto/simulator/simulation-details/simulation-details-interface';
import { SimulationDetailsItemModel } from '../simulation-details-item/simulation-details-item-model';
import { SimulatorDetailsRequestModel } from '../../../request/simulator/details/simulator-details-request-model';

export class SimulationDetailsModel implements SimulationDetailsInterface {
  simulationId?: number = -1;
  proposalId?: number = -1;
  simulationDetailsList?: SimulationDetailsItemModel[] = new Array<SimulationDetailsItemModel>();
  simulationRequestBody?: SimulatorDetailsRequestModel = new SimulatorDetailsRequestModel();
  simulatedProduct?: any;
  campaign?: any = {};

  constructor(init?: Partial<SimulationDetailsModel>) {
    Object.assign(this, init);
  }
}
